import { FeatureCard } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { IAttributes } from 'app/blocks/components/FeatureCardRow/inspector'

const FeatureCardRowBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <>
      <FeatureCard
        title={attributes.card1title}
        body={attributes.card1body ? parse(attributes.card1body) : undefined}
        icon={
          <LazyLoadImage
            src={attributes.card1mediaUrl}
            alt=""
            width="100%"
            height="100%"
            style={{ objectFit: 'contain' }}
          />
        }
      />

      <FeatureCard
        title={attributes.card2title}
        body={attributes.card2body ? parse(attributes.card2body) : undefined}
        icon={
          <LazyLoadImage
            src={attributes.card2mediaUrl}
            alt=""
            width="100%"
            height="100%"
            style={{ objectFit: 'contain' }}
          />
        }
      />
    </>
  )
}

export default FeatureCardRowBlock
